export const API_ENDPOINTS = {
  auth: {
    login: "/api/auth/login",
    register: "/api/auth/register",
    logout: "/api/auth/logout",
  },
  users: {
    list: "/api/users",
    create: "/api/users/create",
    details: (id) => `/api/users/${id}`,
    leaves: (id) => `/api/users/${id}/leaves`,
    leaveDetails: (id, leaveId) => `/api/users/${id}/leaves/${leaveId}`,
    cancelLeave: (id, leaveId) => `/api/users/${id}/leaves/${leaveId}/cancel`,
    compensations: (id) => `/api/users/${id}/compensations`,
    usersByOrg: (orgId) => `/api/users/org/${orgId}`,
    salary: (id) => `/finance/api/v1/users/${id}/salary`,
  },
  merchants: {
    list: "/api/merchants",
    create: "/api/merchants/create",
    details: (id) => `/api/merchants/${id}`,
  },
  documents: {
    upload: "/api/documents/upload",
  },
  salaryFields: {
    getAll: "/finance/api/v1/salary-fields/getAllSalaryFields",
    getById: (id) => `/finance/api/v1/salary-fields/${id}`,
  },
  organizations: {
    payrollComponents: (orgId) =>
      `/finance/api/v1/organizations/${orgId}/payroll-components`,
  },
  finance: {
    base: "/finance/api",
    salaryFields: "/finance/api/v1/salary-fields/getAllSalaryFields",
    salaryFieldById: (id) => `/finance/api/v1/salary-fields/${id}`,
    payrollComponents: (orgId) =>
      `/finance/api/v1/organizations/${orgId}/payroll-components`,
    salary: (id) => `/finance/api/v1/users/${id}/salary`,
    disburse: "/finance/api/v1/salary/disburse",
    ctc: "/finance/api/v1/salary/ctc",
    salarySlips: "/finance/api/v1/salary-slips",
    downloadSalarySlip: "/finance/api/v1/salary-slips/download",
    batchSalaryGen: (orgId) => `/finance/api/v1/${orgId}/salary/batch/gen`,
    salaryPayments: (orgId) => `/finance/api/v1/${orgId}/salary/payments`,
  },
  leaves: {
    base: "/users/api",
    leaveTypes: (orgId) => `/${orgId}/leave-types`,
    orgLeaveCount: (orgId, leaveTypeId) => `/${orgId}/${leaveTypeId}`,
    employeeLeaveCount: (orgId, userId, leaveTypeId) => `/${orgId}/${userId}/${leaveTypeId}`,
    employeeAllLeaveCounts: (orgId, userId) => `/${orgId}/${userId}`,
    apply: (orgId, userId) => `/${orgId}/${userId}/leave/apply`,
    applied: (orgId, userId) => `/${orgId}/${userId}/leave/`,
  },
};

